<template>
  <v-col class="pa-0 fill-height">
    <v-card flat>
      <v-toolbar dense flat class="pa-0 toolbar">
        <v-toolbar-items v-if="needBackButton">
          <BackButton
            class="back-btn"
            :defaultRouter="defaultRouter"
          ></BackButton>
        </v-toolbar-items>
        <v-toolbar-title class="mr-2">{{
          $t(`${resource}.${resource}`)
        }}</v-toolbar-title>
        <v-toolbar-items>
          <template v-for="item in toolbarItems">
            <v-btn
              text
              v-bind:key="'toolbar-items-' + item.title"
              :to="item.to"
              color="primary"
            >
              <v-icon class="mr-2">{{ item.icon }}</v-icon>
              {{ $t(`${resource}.${item.title}`) }}
            </v-btn>
          </template>
        </v-toolbar-items>
      </v-toolbar>
      <v-breadcrumbs
        class="pt-0 px-4 pb-1 breadcrumbs"
        v-if="breadcrumbs.length"
        :items="breadcrumbs"
        ><template v-slot:divider>
          >
        </template>
      </v-breadcrumbs>
      <v-divider></v-divider>
      <template v-if="readyToRender">
        <div class="tabs-container">
          <v-tabs v-model="tabIndex" class="tabs tabs-max-width">
            <template v-for="(item, i) in tabs">
              <v-tab
                v-if="hasPermissions(itemForPermission, item._permissions)"
                :key="i"
                class="tab-item-btn"
              >
                {{ $t(`${resource}.${item.title}`) }}
              </v-tab>
            </template>
          </v-tabs>
          <div class="pr-4 tabs-max-width">
            <v-divider></v-divider>
          </div>
          <v-tabs-items v-model="tabIndex">
            <template v-for="(item, i) in tabs">
              <v-tab-item
                v-if="hasPermissions(itemForPermission, item._permissions)"
                :key="`tab-item-${i}-${item.title}`"
                :class="{
                  'px-4': true,
                  ...(item.tabClass || {}),
                  'tab-item': true
                }"
              >
                <component
                  class="tab-item-component"
                  v-bind:is="item.component"
                  :id="id"
                  :isActiveTab="i === tab"
                ></component>
              </v-tab-item>
            </template>
          </v-tabs-items>
        </div>
      </template>
      <v-container class="loader" v-else>
        <v-overlay absolute z-index="1">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-container>
    </v-card>
  </v-col>
</template>

<script>
import { permissions } from "../../mixins/permissions";
import BackButton from "../buttons/BackButton";
export default {
  name: "CommonTabs",
  components: { BackButton },
  mixins: [permissions],
  props: {
    components: {
      type: Object
    },
    tabs: {
      type: Array
    },
    resource: {
      type: String
    },
    id: {
      type: String
    },
    itemForPermission: {
      type: [Object, Array],
      default: function() {
        return null;
      }
    },
    defaultRouter: {
      type: Object
    },
    tab: {
      type: Number,
      default: 0
    },
    toolbarItems: {
      type: Array,
      default: function() {
        return [];
      }
    },
    needBackButton: {
      type: Boolean,
      default: true
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      tabIndex: this.tab
    };
  },
  computed: {
    readyToRender() {
      if (this.itemForPermission) {
        return Object.keys(this.itemForPermission).length > 0;
      }
      return true;
    }
  },
  watch: {
    tab(val) {
      if (this.tabIndex !== val) this.tabIndex = val;
    },
    tabIndex(val) {
      if (this.tab !== val) this.$emit("update:tab", val);
    }
  },
  beforeMount() {
    this.$options.components = {
      ...this.$options.components,
      ...this.components
    };
  }
};
</script>

<style lang="scss" scoped>
.tabs-container {
  .tab-item {
    .tab-item-component {
      max-width: 892px;
    }
    &.tab-item-full-width {
      .tab-item-component {
        max-width: none;
      }
    }
    &.tab-item-padding-0 {
      padding: 0 !important;
    }
  }
}
.tabs-max-width {
  max-width: 900px;
}
.tabs::v-deep .v-tab {
  min-width: 0 !important;
  &:not(.v-tab--active) {
    color: rgba(0, 0, 0, 0.87) !important;
  }
}

.toolbar::v-deep .v-toolbar__content {
  padding-left: 0;
}
.loader {
  width: 100%;
  height: 480px;
  position: relative;
}
.back-btn {
  min-width: 0 !important;
  padding: 0 12px !important;
}
.breadcrumbs::v-deep {
  li:nth-child(even) {
    padding: 0 1ex;
  }
  a:hover {
    text-decoration: underline;
  }
}
.fill-height {
  min-height: calc(100vh - 68px);
}
</style>
